module.exports = __webpack_public_path__ + "img/background3.4aa12220.webp";